import Rdot360TileView from './Rdot360TileView'

export const DashboardContainer = () => {
  return <Rdot360TileView />
}
